import {Component, OnInit} from '@angular/core';
import {GlobalService} from '../global.service';
import {Router, ActivatedRoute} from '@angular/router';
import {EventsService} from './events.service';
import {AppSettings} from '../app.settings';
import {Meta} from '@angular/platform-browser';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {
  testFolder = './events-templates/';
  eventCode: string = '';

  private host: string = AppSettings.SOCKET_PATH;

  constructor(private Meta: Meta, private activeRoute: ActivatedRoute, private route: Router, public eventService: EventsService, public globalService: GlobalService) {
    this.globalService.enableSwipe = false;
    if (this.globalService.isBrwoser) {

    }
  }


  ngOnInit() {
    if (this.route.url.indexOf('?') != -1) {
      let tempURl = this.route.url.split('?')[0];
      this.eventCode = tempURl.split('/')[1];
    } else {
      this.eventCode = this.route.url.split('/')[1];
    }
    this.eventService.loading = true;
    this.globalService.loadingIndicator = true;
    this.eventService.loadTournaments = true;
    this.eventService.getEvent(this.eventCode).subscribe(response => {
        this.eventService.eventGames = response.games.map(x => x.code)
        this.updateMetaTags(response);
        this.eventService.loading = false;
        this.eventService.Event.next({
          ...response,
          'are_participants_loading': false
        });
        this.globalService.slug = response.slug;
        // if (response.type == 'default' && this.eventCode != 'cfc') {
        //   this.route.navigateByUrl(response.slug + '/tournaments');
        // }
        this.globalService.loadingIndicator = false;
        this.eventService.loadTournaments = false;
        if (response.tournaments) {
          response.tournaments.data.forEach((code, index) => {
            this.eventService.iframeBracket.push(AppSettings.IFRAME + '/bracket/' + code.code);
          });
          this.eventService.Event.value.are_participants_loading = true;
          if (response.tournaments.data.length > 0) {
            this.eventService.getParticipants(response.tournaments.data[0].code, 1).subscribe(res => {
              this.eventService.Event.next({
                ...this.eventService.Event.value,
                'participants': res.participants
              });
              this.eventService.Event.value.are_participants_loading = false;
            });
          }
        }
        this.eventService.ShowQualifiedPlayers(response.slug).subscribe((response) => {
          this.eventService.qualified_Players = response;
        });
        if (this.eventCode == 'cfc') {
          for (let board = 0; board < 18; board++) {
            this.eventService.getLeaderBoard(board + 1).subscribe(res => {
              this.eventService.cfcLeaderBoard[board] = (res);
            })
            this.eventService.getCFCStats(board + 1).subscribe(res => {
              this.eventService.cfcLeaderBoardStats[board] = (res);
            })
          }
          this.eventService.cfcLoadStats = true;
          this.eventService.getCFCStats('all').subscribe(res => {
            this.eventService.cfcAllStats = (res);
            this.eventService.cfcLoadStats = false;
          })

        }
        // if (this.eventCode != 'halloween-nights'&&this.eventCode != 'insomnia-egypt19'&&this.eventCode != 'winter-wonder'&& this.eventCode != 'christmas' , this.eventCode !='shawarmer',this.eventCode !='friend-zone') {
        //   this.eventService.loadEventTournaments = true;
        //   this.eventService.getEventTournaments(response.slug, 1).subscribe(res => {
        //     this.eventService.eventTournaments.next(Object.assign(this.eventService.eventTournaments.value, res));
        //     this.eventService.loadEventTournaments = false;
        //   })
        // }
      },
      error => {
        this.eventService.loading = false;
        this.globalService.loadingIndicator = false;
        this.eventService.loadTournaments = false;
      });


  }


  updateMetaTags(data) {
    this.Meta.updateTag({
        property: 'og:url',
        content: 'https://events.gbarena.com/' + data.slug
      }
    );
    this.Meta.updateTag({
      property: 'og:title',
      content: data.name
    });
    /* update description (fb,google), image and URl*/
    this.Meta.updateTag({
      property: 'og:description',
      content: data.description
    });
    this.Meta.updateTag({
      property: 'og:image',
      content: data.cover_picture ? data.cover_picture : data.profile_picture
    });
    this.Meta.updateTag({
      name: 'description',
      content: data.description
    });
    this.Meta.updateTag({
        name: 'keywords',
        content: data.name + ',Event,GBarena, GBarena Event, PUBG, Fortnite, ' +
          'esports Middle East, esports Egypt, Esports, League of Legends Egypt'
      }
    );
  }
}
